import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Copy, Icon, Currency } from '@elparking/components'
import { Comment, Container } from '../../ui'

import DateTime from 'commons/js/ui/DateTime'
import { FormattedMessage } from 'react-intl'
import { LOCALE_DATETIME_HUMAN_SHORT_FORMAT } from 'commons/js/constants'

export const TYPE_CLAIM = 'claim'
export const TYPE_FEEDBACK = 'feedback'

export const getConversation = (claims) => {
    let conversations = []
    claims.forEach(({feedbacks, ...claim}) => {
        conversations.push({
           ...claim,
            type: TYPE_CLAIM,
        })
        feedbacks.map((feedback) => {
            conversations.push({
                ...feedback,
                type: TYPE_FEEDBACK,
            })
        })
    })
    conversations.sort(({ date: dateA }, { date: dateB }) => (dateA - dateB))
    return conversations
}

const Conversation = ({ fine, expanded: exp }) => {
    const [expanded, setExpanded] = useState(exp)
    const conversations = getConversation(fine.claims)
    return (<Box mt='2em' background='lightGray20' p='1em 0.5em'>
        {!expanded && <Button.unstyled onClick={() => setExpanded(!expanded)}>
            <Copy padding='0' fontWeight='book' fontColor='main' fontSize='xSmall'>
                <Icon color='main' type='arrow-down' /> <FormattedMessage defaultMessage='Mostrar reclamaciones' />
            </Copy>
        </Button.unstyled> }
        {expanded && <Box textAlign='right'>
            <Button.unstyled fontSize='small' onClick={() => setExpanded(!expanded)}>
                <Copy as='span' padding='0 0.5em' fontWeight='book' fontColor='gray60' fontSize='xSmall'>
                    <FormattedMessage defaultMessage='Ocultar reclamaciones' />
                </Copy> <Icon color='main' type='arrow-up' />
            </Button.unstyled>
        </Box>}
        { expanded && <Container width='100%'>
            { conversations.map((item, cIndex) => (
                item.type === TYPE_CLAIM
                ? <Box key={`comment_${cIndex}`}>
                    <Box mb='0.3em' mt='1em' textAlign='right'>
                        { item.user && <Copy textAlign='right' fontWeight='book' fontColor='main' fontSize='xxxSmall' padding='0 0.5em'>
                            {item.user}
                        </Copy> }
                        <Comment mb='0.3em' maxWidth='90%' color='darkMain'>
                            <Copy padding='0 0 0.5em 0' fontSize='xxSmall' fontColor='white' fontWeight='medium'>
                                {item.reason}
                            </Copy>
                            <Copy padding='0 0 0.5em 0' fontSize='xSmall' fontColor='main40' fontWeight='book'>
                                {item.description}
                            </Copy>
                            <Copy textAlign='right' fontSize='xxxSmall' fontColor='main40' transform='uppercase' padding='0'>
                                <DateTime value={item.date} format={LOCALE_DATETIME_HUMAN_SHORT_FORMAT} timeZone={fine.parkingTimeZone} />
                            </Copy>
                        </Comment>
                    </Box>
                </Box>
                : <Box mt='0.3em' key={`response_${cIndex}`} textAlign='left'>
                    { item.user && <Copy fontWeight='book' fontSize='xxxSmall' padding='0 0.5em'>
                        {item.user}
                    </Copy> }
                    <Comment mb='0.3em' left maxWidth='90%' color='gray'>
                        <Copy padding='0 0 0.5em 0' fontSize='xSmall' fontColor='lightGray40' fontWeight='book'>
                            {item.comments}
                        </Copy>
                        { item.resolution && item.price && <Copy padding='0 0 0.5em 0' fontSize='xSmall' fontColor='white' fontWeight='medium'>
                            <FormattedMessage defaultMessage='Precio final:' /> <Currency qty={item.price} />
                        </Copy> }
                        <Copy textAlign='left' fontSize='xxxSmall' fontColor='lightGray' transform='uppercase' padding='0'>
                            <DateTime value={item.date} format={LOCALE_DATETIME_HUMAN_SHORT_FORMAT} timeZone={fine.parkingTimeZone} />
                        </Copy>
                    </Comment>
                </Box>
            )) }
        </Container>}
    </Box>)
}

Conversation.propTypes = {
    expanded: PropTypes.bool.isRequired,
    fine: PropTypes.shape({
        parkingTimeZone: PropTypes.string,
        claims: PropTypes.arrayOf(PropTypes.shape({
            date: PropTypes.number,
            user: PropTypes.string,
            reason: PropTypes.string,
            status: PropTypes.number,
            description: PropTypes.string,
            feedbacks: PropTypes.arrayOf(PropTypes.shape({
                comments: PropTypes.string,
                price: PropTypes.shape({
                    amount: PropTypes.number,
                    currency: PropTypes.string,
                }),
                date: PropTypes.number,
                user: PropTypes.string,
                resolution: PropTypes.bool,
            })),
        })).isRequired,
    }),
}

Conversation.defaultProps = {
    expanded: false,
}

export default Conversation
